import {IOpenOrders} from '../../models/OpenOrders';

export const FETCH_OPEN_ORDERS = 'FETCH_OPEN_ORDERS';
export const FETCH_OPEN_ORDERS_SUCCESS = 'FETCH_OPEN_ORDERS_SUCCESS';
export const FETCH_OPEN_ORDERS_ERROR = 'FETCH_OPEN_ORDERS_ERROR';

export interface FetchOpenOrders {
  type: typeof FETCH_OPEN_ORDERS;
}

export interface FetchOpenOrdersSuccess {
  type: typeof FETCH_OPEN_ORDERS_SUCCESS;
  payload: IOpenOrders;
}

export interface FetchOpenOrdersError {
  type: typeof FETCH_OPEN_ORDERS_ERROR;
}

export type OpenOrdersActions =
  | FetchOpenOrders
  | FetchOpenOrdersSuccess
  | FetchOpenOrdersError;
